export default "__VITE_ASSET__TifcAHir__"